import { keepPreviousData, useQuery } from '@tanstack/react-query'
import {
  GETDatabusMessageLogs,
  GetDatabusMessageLogsParams,
} from './requests.ts'

export function useDatabusMessageLogs(
  params: GetDatabusMessageLogsParams,
  enabled = true
) {
  return useQuery({
    queryKey: ['databus_message_logs', params],
    queryFn: () => GETDatabusMessageLogs(params),
    placeholderData: keepPreviousData,
    refetchOnMount: 'always',
    enabled,
  })
}
